<template>
  <header class="content-header" :class="{ 'bg-red': this.$route.name !== 'Home' || isScrolled || isScrolledMobile }">
    <div class="content-header-itens container">
      <router-link tag="a" to="/home" class="content-header-itens-logo">
        <img src="@/assets/img/header/logo.png" alt="logo">
      </router-link>
      <div class="content-header-itens-links">
        <router-link tag="a" to="/home" class="content-header-itens-link-items">
          <p>início</p>
        </router-link>
        <router-link tag="a" to="/prizes" class="content-header-itens-link-items">
          <p>prémios</p>
        </router-link>
        <router-link tag="a" to="/faqs" class="content-header-itens-link-items">
          <p>Perguntas frequentes</p>
        </router-link>
      </div>
      <template v-if="userIsLogged">
        <router-link tag="a" to="/account" class="content-header-itens-btn d-none" >
          <svg xmlns="http://www.w3.org/2000/svg" width="21.505" height="24.576" viewBox="0 0 21.505 24.576">
            <path id="user" d="M10.753,12.289A6.144,6.144,0,1,0,4.608,6.144,6.144,6.144,0,0,0,10.753,12.289Zm0-10.753A4.608,4.608,0,1,1,6.144,6.144,4.613,4.613,0,0,1,10.753,1.536Zm2.434,13.057H8.319A8.32,8.32,0,0,0,0,22.911a1.664,1.664,0,0,0,1.664,1.664H19.842a1.661,1.661,0,0,0,1.663-1.664A8.319,8.319,0,0,0,13.186,14.593Zm6.653,8.448H1.664a.129.129,0,0,1-.128-.13,6.791,6.791,0,0,1,6.783-6.783h4.863a6.792,6.792,0,0,1,6.788,6.783A.129.129,0,0,1,19.839,23.041Z" fill="#173f35"/>
          </svg>
          <p>{{ this.user.nome.substring(0, 8) + '...' }}</p>
        </router-link>
      </template>
      <template v-else>
        <div class="content-header-itens-btn d-none" @click="scrollToElement()">
          <svg xmlns="http://www.w3.org/2000/svg" width="21.505" height="24.576" viewBox="0 0 21.505 24.576">
            <path id="user" d="M10.753,12.289A6.144,6.144,0,1,0,4.608,6.144,6.144,6.144,0,0,0,10.753,12.289Zm0-10.753A4.608,4.608,0,1,1,6.144,6.144,4.613,4.613,0,0,1,10.753,1.536Zm2.434,13.057H8.319A8.32,8.32,0,0,0,0,22.911a1.664,1.664,0,0,0,1.664,1.664H19.842a1.661,1.661,0,0,0,1.663-1.664A8.319,8.319,0,0,0,13.186,14.593Zm6.653,8.448H1.664a.129.129,0,0,1-.128-.13,6.791,6.791,0,0,1,6.783-6.783h4.863a6.792,6.792,0,0,1,6.788,6.783A.129.129,0,0,1,19.839,23.041Z" fill="#173f35"/>
          </svg>
          <p>Entrar</p>
        </div>
      </template>
      <div class="content-menu d-lg-none" @click="setMenuOpen(true)">
        <div class="content-menu-item">
          <span></span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      openMenuDesktop: false,

    };
  },
  props: {
    isScrolled: Boolean,
    isScrolledMobile: Boolean,
  },
  computed: {
    ...mapGetters(['isDesktop', 'activeMenuFooter', 'activeFormFloating','userIsLogged', 'user']),
  },
  methods: {
    ...mapMutations(['setActiveMenuFooter',]),
    ...mapActions(["setMenuOpen","toggleFormFixed"]),
    menuDesktopOpen(){
      if (this.openMenuDesktop){
        this.openMenuDesktop = false;
      } else {
        this.openMenuDesktop = true;
      }
    },

    scrollToElement() {
      if (this.$route.name !== 'Home') {
        localStorage.setItem('scrollToElement', true);
        window.location.href = '/home';
      }
      setTimeout(() => {
        this.$scrollTo('#login', 800, { easing: 'linear' });
      }, 1000);
    },

  },
  
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>